if (!customElements.get('checkout-timeout')) {
    class CheckoutTimeout extends HTMLElement {

        constructor() {
            super();
            this.text = this.querySelector('.js-checkout-interval-text');
            this.template = this.dataset.template;
            this.confirmationPage = this.dataset.confirmationPage;
            this.started = false;
            this.interval = null;
            this.updateTriggered = false;
            this.pauseAt = null;
        }

        connectedCallback() {
            const now = new Date().getTime();
            const timeout = parseInt(localStorage.getItem('checkout_timeout'));

            if (now > timeout) {
                localStorage.removeItem('checkout_timeout');
                clearInterval(this.interval);
                this.started = false;
            } else {
                this.startTimeout();
            }

            document.addEventListener('timeout:start', this.startTimeout.bind(this));
            document.addEventListener('timeout:pause', this.pauseTimeout.bind(this));
            document.addEventListener('timeout:resume', this.resumeTimeout.bind(this));
        }

        disconnectedCallback() {
            document.removeEventListener('timeout:start', this.startTimeout.bind(this));
            document.removeEventListener('timeout:pause', this.pauseTimeout.bind(this));
            document.removeEventListener('timeout:resume', this.resumeTimeout.bind(this));
        }

        pauseTimeout() {
            this.pauseAt = new Date().getTime();
            clearInterval(this.interval);
        }

        resumeTimeout() {
            const diff = new Date().getTime() - this.pauseAt;
            const timeout_time = parseInt(localStorage.getItem('checkout_timeout')) + diff;
            const checkout_update_timeout = parseInt(localStorage.getItem('checkout_update_checkout_timeout') || '0') + diff;
            localStorage.setItem('checkout_timeout', timeout_time);
            localStorage.setItem('checkout_update_checkout_timeout', checkout_update_timeout);
            this.interval = setInterval(this.timeInterval.bind(this), 1000);
        }

        startTimeout() {
            if (this.started) return;
            if (localStorage.getItem('checkout_timeout') && (parseInt(localStorage.getItem('checkout_timeout')) - new Date().getTime())) {
                this.interval = setInterval(this.timeInterval.bind(this), 1000);
                setTimeout(() => { this.classList.add('running') }, 1500);
            }
        }

        timeInterval() {
            const timeout_time = parseInt(localStorage.getItem('checkout_timeout'));
            const checkout_update_timeout = parseInt(localStorage.getItem('checkout_update_checkout_timeout') || '0');

            var distance = timeout_time - new Date().getTime();
            var update_checkout_distance = checkout_update_timeout - new Date().getTime();

            if (!localStorage.getItem('checkout_timeout') || distance <= 0) {
                this.classList.remove('running');
                this.started = false;
                localStorage.removeItem('checkout_timeout');
                clearInterval(this.interval);
                return;
            }

            if (!this.updateTriggered && update_checkout_distance <= 0) {
                this.updateTriggered = true;
                this.finishCheckoutByTimeout();
            }

            var minutes = Math.floor((update_checkout_distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((update_checkout_distance % (1000 * 60)) / 1000);

            if (minutes < 0) {
                minutes = 0;
            }
            if (seconds < 0) {
                seconds = 0;
            }

            this.text.innerText = this.template.replace('##COUNTDOWN##', ` ${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`);
        }

        async finishCheckoutByTimeout() {
            //return window.checkout._sendApprove();
            return window.checkout?.handleApprove();
        }

        _itemsPayload(items) {

            items = this._filterDummy(items);
            items = this._filterCheckoutItems(items);
            items = this._modifyForBackend(items);
            items = this._transformReduce(items);

            return items;
        }

        _transformReduce(items) {
            return items;
            // return items.map(({ id, handle, properties, quantity, variant_id, key, title, price, discounts, product_id, line_level_discount_allocations }) => { id, handle, properties, quantity, variant_id, key, title, price, discounts, product_id, line_level_discount_allocations });
        }

        _modifyForBackend(items) {
            return items
                .map((item) => {
                    if (!Object.keys(item.properties).includes('_resolved') && Object.keys(item.properties).includes('_answer_type') && item.properties['_answer_type'] == 'E') {
                        return {
                            ...item,
                            quantity: parseInt(item.properties['_available'])
                        }
                    }
                    return item;
                })
                .filter((item) => item.quantity > 0);
        }

        _filterCheckoutItems(items) {

            return items.filter(({ id, quantity, properties }) => {

                if (Object.keys(properties).includes('_canceled') && properties['_canceled'] == true) {
                    return false;
                }

                if (Object.keys(properties).includes('_deposit') && properties['_deposit'] == true) {
                    return false;
                }

                if (!Object.keys(properties).includes('_possible_next_delivery_date')) {
                    return true;
                }

                if (Object.keys(properties).includes('_answer_type') && ['I', 'S'].includes(properties['_answer_type'])) {
                    return true;
                }

                const hasAlternativeDeliveryProduct = items
                    .filter(() => !Object.keys(properties).includes('_resolved'))
                    .filter((currentItem) => currentItem.id == id)
                    .filter((currentItem) => Object.keys(currentItem.properties).includes('_resolved'))
                    .filter((currentItem) => Object.keys(currentItem.properties).includes('_next_delivery_date'))
                    .filter((currentItem) => currentItem.properties['_next_delivery_date'] == properties['_possible_next_delivery_date'])
                    .filter((currentItem) => quantity == currentItem.quantity)
                    .length > 0;

                if (hasAlternativeDeliveryProduct) {
                    return false;
                }

                return true;
            });
        }

        _filterDummy(items) {
            return items.filter(({ product_id }) => window.settings.dummy.product_id != product_id);
        }
    }

    customElements.define('checkout-timeout', CheckoutTimeout);
}